// Kept out of edit_customer.js so it can be unit tested without a DOM. The trim below is structural,
// not cosmetic: the contact autocomplete renders a single space when the funding has no contact (see
// customer_html/selector_contact.heex), so dropping it would make every funding row look filled and
// no customer would ever save.
export function fieldHoldsInput({ name, type, value, checked }) {
  // Rendered as a sibling of the row by inputs_for/4 today, so it never reaches this function - but a
  // move to the LiveView component would put it inside the row, and every persisted row would block.
  if (name.endsWith("[id]")) {
    return false;
  }

  // Same rule as the server: the subrogation checkbox only counts when it submits "true". Its
  // companion hidden input submits "false" on every untouched row, and a row cloned by the "add a
  // funder" button keeps the ticked state with an emptied value, so it submits nothing.
  if (name.endsWith("[subrogation]")) {
    return type === "checkbox" && checked && value === "true";
  }

  return value.trim() !== "";
}
